import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class FootprintApiManager_ds_entity_user_defined_fieldsService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }


  public async getList($inParams: { EntityType: string, $top?: number, $skip?: number }): Promise<{ result?: { UdfName?: string }[], totalCount?: number }> {
    const $missingRequiredInParams = [];
    if (isNil($inParams.EntityType)) {
      $missingRequiredInParams.push('\'EntityType\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }

    
    hasMissingRequiredInParams($inParams: { 
      EntityType: string    }) {
        if(isNil($inParams.EntityType)) {
          return true; 
        }
      return false;
    }
}
